/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */

export type DatasetRoleID = (typeof DatasetRoleID)[keyof typeof DatasetRoleID];

export const DatasetRoleID = {
  ADMIN: 'admin',
  COLLABORATOR: 'collaborator',
  CUSTOMER: 'customer',
} as const;
